import { Controller } from "@hotwired/stimulus"

// Toggles the "scroll"/"noScroll" padding classes based on whether a vertical scrollbar is present (via ResizeObserver).
export default class extends Controller {
  static classes = [ "scroll", "noScroll" ]

  connect() {
    this.refresh = this.refresh.bind(this)
    this.observer = new ResizeObserver(this.refresh)
    this.observer.observe(this.element)
    for (const child of this.element.children) this.observer.observe(child)
    this.refresh()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  refresh() {
    const scrolling = this.element.scrollHeight > this.element.clientHeight
    if (scrolling === this.scrolling) return
    this.scrolling = scrolling
    this.element.classList.toggle(this.scrollClass, scrolling)
    this.element.classList.toggle(this.noScrollClass, !scrolling)
  }
}
